import axios, { AxiosPromise } from 'axios';
import {
  IGetSemesterEvaluationHW,
  IGetSemesterEvaluationPbtItems,
  IGetSemesterEvaluationPbtItemsParams,
  IGetSemesterEvaluations,
  IGetSemesterEvaluationsHWParams,
  IGetSemesterEvaluationsParams,
  IPostSemesterEvaluation,
  IPostSemesterEvaluationHW,
  IPostSemesterEvaluationHWReq,
  IPostSemesterEvaluationPbtItem,
  IPostSemesterEvaluationPbtItemReq,
  IPostSemesterEvaluationReq,
  IPutSemesterEvaluationPbtItem,
  IPutSemesterEvaluationPbtItemReq,
} from '../models/semesterEvaluation.model';

const uri = '/mgmt/semester-evaluation';

export const getSemesterEvaluations = (params: IGetSemesterEvaluationsParams): AxiosPromise<IGetSemesterEvaluations> => {
  return axios.get(uri, { params });
};

export const postSemesterEvaluation = (req: IPostSemesterEvaluationReq): AxiosPromise<IPostSemesterEvaluation> => {
  return axios.post(uri, req);
};

export const putSemesterEvaluation = (evaluationCode: number, req: IPostSemesterEvaluationReq): AxiosPromise<IPostSemesterEvaluation> => {
  return axios.put(`${uri}/${evaluationCode}`, req);
};

export const deleteSemesterEvaluation = (evaluationCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${evaluationCode}`);
};

export const postSemesterEvaluationHW = (
  req: IPostSemesterEvaluationHWReq,
): AxiosPromise<IPostSemesterEvaluationHW> => axios.post(`${uri}/hw`, req);

export const putSemesterEvaluationHW = (
  evaluationCode: number,
  req: IPostSemesterEvaluationHWReq,
): AxiosPromise<IPostSemesterEvaluationHW> =>
  axios.put(`${uri}/hw/${evaluationCode}`, req);

export const getSemesterEvaluationHW = (
  params: IGetSemesterEvaluationsHWParams,
): AxiosPromise<IGetSemesterEvaluationHW> => axios.get(`${uri}/hw`, { params });

export const getSemesterEvaluationPbtItems = (params: IGetSemesterEvaluationPbtItemsParams): AxiosPromise<IGetSemesterEvaluationPbtItems> => {
  return axios.get(`${uri}/pbt`, { params });
};

export const postSemesterEvaluationPbtItem = (req: IPostSemesterEvaluationPbtItemReq): AxiosPromise<IPostSemesterEvaluationPbtItem> => {
  return axios.post(`${uri}/pbt`, req);
};

export const putSemesterEvaluationPbtItem = (evaluationCode: number, req: IPutSemesterEvaluationPbtItemReq): AxiosPromise<IPutSemesterEvaluationPbtItem> => {
  return axios.put(`${uri}/pbt/${evaluationCode}`, req);
};